import { UserMe } from 'types/api/User';
import { useAppSelector } from 'store/config';

function useCurrentUser() {
  return useAppSelector(state => state.user) as UserMe;
}

export default useCurrentUser;
